


































































import { Component, Prop, Vue } from 'vue-property-decorator'
@Component
export default class GroupList extends Vue {
  @Prop() private data!: any
}
